<template>
  <v-container fluid grid-list-md pa-0>
    <v-layout row wrap>
      <v-flex xs12 md8>
        <v-layout row wrap>
          <v-flex>
            <AnalysisChart :plantId="getSelectedPlantId" :selectedId="selectedCard"
              @selectedTab="selectedTabHandler" @sideCardData="sideCardData"
              @totalCardData="totalCardData" :callSummaryApi="callSummaryApi" />
          </v-flex>
          <v-flex>
            <AnalysisTotalLossCard :totalCard="totalCard" />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4 child-flex>
        <AnalysisSideCard :active="tab" :cardData="sideCard" @cardSelected="cardSelectedHandler"
          :reset="getSelectedPlantId" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash'
import {
  mapGetters
} from 'vuex'
import {
  filterMixin
} from '@/util/mixin/index'
import IEcharts from 'vue-echarts-v3/src/full.js'
import AnalysisSideCard from '@/components/downTimeAnalysis/AnalysisSideCard'
import AnalysisTotalLossCard from '@/components/downTimeAnalysis/AnalysisTotalLossCard'
import AnalysisChart from '@/components/downTimeAnalysis/AnalysisChart'

export default {
  mixins: [filterMixin],
  components: {
    IEcharts,
    AnalysisSideCard,
    AnalysisTotalLossCard,
    AnalysisChart
  },
  data() {
    return {
      tab: '',
      totalCard: {},
      sideCard: [],
      selectedCard: '',
      callSummaryApi: 0
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId'])
  },
  methods: {
    selectedTabHandler(val) {
      this.tab = val
    },
    totalCardData(val) {
      this.totalCard = _.cloneDeep(val)
    },
    sideCardData(val) {
      this.sideCard = [...val]
    },
    cardSelectedHandler(payload) {
      this.selectedCard = payload.id
      this.callSummaryApi = payload.componentHasBeenReset
    }
  }
}
</script>
